import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    tabsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    contentContainer: {
        width: "100%",
        flex: 1
    },
    container: {
        width: "100%",
        flex: 1
    },
    titleContainer: {}
});
export default stylesheet;
